import { Input } from "antd";
import { SketchPicker } from "react-color";
import { CgColorPicker } from "react-icons/cg";

export const InputColor = ({
  value,
  onChange,
  onClick,
  togglePicker,
  ...props
}) => {
  return (
    <Input
      onChange={(e) => onChange(e.target.value)}
      size="large"
      prefix={
        <>
          <CgColorPicker
            onClick={(e) => onClick(e)}
            style={{
              background: value,
              color: value ? "white" : "gray",
              width: 30,
              padding: 5,
              height: "100%",
              borderRadius: 8,
              border: "1px solid #d9d9d9",
            }}
          />

          {togglePicker && (
            <div
              style={{
                position: "absolute",
                top: 60,
                zIndex: 9999,
              }}
            >
              <SketchPicker
                color={value}
                onChange={(e) =>
                  onChange(`rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`)
                }
              />
            </div>
          )}
        </>
      }
      style={{ borderRadius: 8 }}
      value={value}
      {...props}
    />
  );
};
